module.exports = __webpack_public_path__ + "static/media/12-10.980bb499.mp3";